<template>
  <header class="pa-header pa-header-front pa-front-page-logo">
    <div class="for-mobile">
      <router-link :to="{name: 'index'}">
        <HeaderLogoSmall class="small" />
      </router-link>
    </div>
    <div class="for-wide">
      <router-link :to="{name: 'index'}">
        <HeaderLogoWide class="wide" />
      </router-link>
    </div>
  </header>
</template>

<script>
import HeaderLogoSmall from '@/components/FrontParts/FrontPageLogo/Images/pages_logo_small.svg?inlineN'
import HeaderLogoWide  from '@/components/FrontParts/FrontPageLogo/Images/pages_logo_wide.svg?inlineN'

export default {
  components : {
    HeaderLogoSmall,
    HeaderLogoWide
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/_variables.scss";
@import "~bulma/sass/utilities/_all";

.pa-header{
  &-front{
    &.pa-front-page-logo{
      div.for-mobile{
        @include from($tablet) {
          display: none;
        }

        @include until($tablet) {
          display: block;
        }

        svg.small{
          .cls-1 {
            fill: #993d59;
          }

          .cls-2 {
            fill: #540e23;
          }

          .cls-3 {
            fill: #962349;
          }

          .cls-4 {
            fill: #d5bf9b;
          }
        }
      }

      div.for-wide{
        background: -webkit-linear-gradient(#540E23 0%, #540E23 10%, #962349 10%, #962349 12%, #993D59 12%, #993D59 22%, #540E23 22%, #540E23 32%, #962349 32%, #962349 34%, #993D59 34%, #993D59 44%, #540E23 44%, #540E23 54%, #962349 54%, #962349 56%, #993D59 56%, #993D59 66%, #540E23 66%, #540E23 76%, #962349 76%, #962349 78%, #993D59 78%, #993D59 88%, #540E23 88%, #540E23 98%, #962349 98%, #962349 100%);
        background: -o-linear-gradient(#540E23 0%, #540E23 10%, #962349 10%, #962349 12%, #993D59 12%, #993D59 22%, #540E23 22%, #540E23 32%, #962349 32%, #962349 34%, #993D59 34%, #993D59 44%, #540E23 44%, #540E23 54%, #962349 54%, #962349 56%, #993D59 56%, #993D59 66%, #540E23 66%, #540E23 76%, #962349 76%, #962349 78%, #993D59 78%, #993D59 88%, #540E23 88%, #540E23 98%, #962349 98%, #962349 100%);
        background: linear-gradient(#540E23 0%, #540E23 10%, #962349 10%, #962349 12%, #993D59 12%, #993D59 22%, #540E23 22%, #540E23 32%, #962349 32%, #962349 34%, #993D59 34%, #993D59 44%, #540E23 44%, #540E23 54%, #962349 54%, #962349 56%, #993D59 56%, #993D59 66%, #540E23 66%, #540E23 76%, #962349 76%, #962349 78%, #993D59 78%, #993D59 88%, #540E23 88%, #540E23 98%, #962349 98%, #962349 100%);
        text-align: center;
        padding:.8rem 0;

        svg.wide{
          max-width: 280px;
          .cls-1 {
            fill: #d5bf9b;
          }
        }

        @include from($tablet) {
          display: block;
        }

        @include until($tablet) {
          display: none;
        }
      }
    }
  }
}
</style>